<template>  
  <div class="modal-card modal-card--md">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Temporary Admin Modal
      </p>
      <a class="close-modal" aria-label="close" @click="closeModal()">
        <i class="material-icons">close</i>
      </a>
    </header>
    <section class="modal-card-body">
      <h5>
        Delete all profiles
      </h5>
      <p>
        Deletes all profiles. Useful as the profile data model has changed.
      </p>
      <button class="button" @click="deleteAllProfiles()" :disabled="deleting">
        Delete
      </button>
    </section>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class AdminModal extends Vue {
  public deleting: boolean = false;

  public closeModal() {
    this.$store.commit('setModal', '');
  }

  public deleteAllProfiles() {
    this.deleting = true;
    try {
      this.$store.dispatch('deleteAllProfiles');
    } catch (e) {
      this.$store.commit('setToastError', 'Error deleting profiles');
    }
    this.deleting = false;
  }
}

</script>

<style scoped lang="scss">

</style>